import ua from '@tencent/docs-user-agent';

const isWindowsChrome = () => ua.isChrome && ua.isWindows && !ua.isWxWork && !ua.isWeChat;

/**
 * 处理 pc 端导出
 * @param {string} url
 */
export function handlePcExport(url: string) {
    // windows 下面的 chrome 下面用 frame 的方式打开下载会有一定几率导致崩溃 去掉微信（会出现 400 弹窗）
    if (isWindowsChrome()) {
        const newPage = global.open(url, '_blank');
        if (!newPage) {
            openDownloadInFrame(url);
        }
        return;
    }

    if (ua.isWxWork) {
        openDownloadWithLink(url);
        return;
    }

    // 默认兜底逻辑
    openDownloadInFrame(url);
}


/**
 * 用frame的方式打开一个页面进行下载
 * @param {string} url
 */
export function openDownloadInFrame(url: string, idName?: string | number): HTMLElement {
    // 取消打开新窗口模式
    const id = `exportIframe-${idName}`;
    const exportIframe = document.createElement('iframe');
    exportIframe.id = id;
    exportIframe.src = '';
    exportIframe.style.display = 'none';

    // 改写成非 jQuery 形式
    const oldFrame = document.querySelector(`#${id}`);
    if (oldFrame) {
        document.body.removeChild(oldFrame);
    }
    document.body.appendChild(exportIframe);
    exportIframe.setAttribute('src', url);
    return exportIframe;
}

/**
 * 适配企业微信导出
 * @param {string} url
 */
export function openDownloadWithLink(url: string): void {
    const exportLinkDom = document.createElement('a');
    exportLinkDom.id = 'linkDwnldLink';
    exportLinkDom.href = url;
    const oldLinkDom = document.getElementById('linkDwnldLink');
    if (oldLinkDom) {
        document.body.removeChild(oldLinkDom);
    }
    document.body.appendChild(exportLinkDom);
    exportLinkDom?.setAttribute('download', '');
    exportLinkDom?.click();
}

export default handlePcExport;
